import { findFocusAreaFromLogos, FocusArea } from '@/domain/mockups/focusArea';
import { computeCameraWithAngle } from './styleLookAt';
const FocusToAngle = new Map();
FocusToAngle.set(FocusArea.FRONT, 0);
FocusToAngle.set(FocusArea.BACK, Math.PI);
FocusToAngle.set(FocusArea.RIGHT, -Math.PI * 0.5);
FocusToAngle.set(FocusArea.LEFT, Math.PI * 0.5);
FocusToAngle.set(FocusArea.UNDEFINED, 0);
/**
 * Compute camera rotation based on logo placements.
 * @param styleRegions - Style regions.
 * @param logos - Mockup logos.
 */
export const computeCameraRotationY = (styleRegions, logos) => {
    const focus = findFocusAreaFromLogos(styleRegions, logos);
    const angle = FocusToAngle.get(focus);
    return angle;
};
/**
 * Compute preview camera rotation based on style and logo placements.
 * @param style - Style.
 * @param styleRegions - Style regions.
 * @param logos - Mockup logos.
 */
export const computePreviewRotationY = (style, styleRegions, logos) => {
    const focusArea = findFocusAreaFromLogos(styleRegions, logos);
    let angle = FocusToAngle.get(focusArea);
    // Account for special category headwear treatment
    if (style.type.toLowerCase() === 'headwear' &&
        focusArea !== FocusArea.LEFT &&
        focusArea !== FocusArea.RIGHT) {
        angle -= Math.PI * 0.28;
    }
    return angle;
};
/**
 * Compute camera look-at based on style and logo placements.
 * @param style - Style.
 * @param styleRegions - Style regions.
 * @param styleScene - Style scene.
 * @param logos - Mockup logos.
 */
export const computePreviewLookAt = (style, styleRegions, styleScene, logos, fov, screenRatio = 1) => {
    const angleY = computePreviewRotationY(style, styleRegions, logos);
    const camera = computeCameraWithAngle(styleScene, fov, angleY, screenRatio);
    return camera;
};
